/** @jsx jsx */
import { jsx } from '@emotion/core'
import SportsID1Img from '@assets/images/icon/sports_icon/gray/sport_id_1.png'
import SportsID2Img from '@assets/images/icon/sports_icon/gray/sport_id_2.png'
import SportsID3Img from '@assets/images/icon/sports_icon/gray/sport_id_3.png'
import SportsID4Img from '@assets/images/icon/sports_icon/gray/sport_id_4.png'
import SportsID5Img from '@assets/images/icon/sports_icon/gray/sport_id_5.png'
import SportsID6Img from '@assets/images/icon/sports_icon/gray/sport_id_6.png'
import SportsID7Img from '@assets/images/icon/sports_icon/gray/sport_id_7.png'
import SportsID9Img from '@assets/images/icon/sports_icon/gray/sport_id_9.png'
import SportsID10Img from '@assets/images/icon/sports_icon/gray/sport_id_10.png'
import SportsID11Img from '@assets/images/icon/sports_icon/gray/sport_id_11.png'
import SportsID12Img from '@assets/images/icon/sports_icon/gray/sport_id_12.png'
import SportsID13Img from '@assets/images/icon/sports_icon/gray/sport_id_13.png'
import SportsID14Img from '@assets/images/icon/sports_icon/gray/sport_id_14.png'
import SportsID15Img from '@assets/images/icon/sports_icon/gray/sport_id_15.png'
import SportsID16Img from '@assets/images/icon/sports_icon/gray/sport_id_16.png'
import SportsID17Img from '@assets/images/icon/sports_icon/gray/sport_id_17.png'
import SportsID18Img from '@assets/images/icon/sports_icon/gray/sport_id_18.png'
import SportsID19Img from '@assets/images/icon/sports_icon/gray/sport_id_19.png'
import SportsID20Img from '@assets/images/icon/sports_icon/gray/sport_id_20.png'
import SportsID21Img from '@assets/images/icon/sports_icon/gray/sport_id_21.png'
import SportsID22Img from '@assets/images/icon/sports_icon/gray/sport_id_22.png'
import SportsID23Img from '@assets/images/icon/sports_icon/gray/sport_id_23.png'
import SportsID24Img from '@assets/images/icon/sports_icon/gray/sport_id_24.png'
import SportsID25Img from '@assets/images/icon/sports_icon/gray/sport_id_25.png'
import SportsID26Img from '@assets/images/icon/sports_icon/gray/sport_id_26.png'
import SportsID28Img from '@assets/images/icon/sports_icon/gray/sport_id_28.png'
import SportsID29Img from '@assets/images/icon/sports_icon/gray/sport_id_29.png'
import SportsID31Img from '@assets/images/icon/sports_icon/gray/sport_id_31.png'
import SportsID32Img from '@assets/images/icon/sports_icon/gray/sport_id_32.png'
import SportsID34Img from '@assets/images/icon/sports_icon/gray/sport_id_34.png'
import SportsID36Img from '@assets/images/icon/sports_icon/gray/sport_id_36.png'
import SportsID37Img from '@assets/images/icon/sports_icon/gray/sport_id_37.png'
import SportsID38Img from '@assets/images/icon/sports_icon/gray/sport_id_38.png'
import SportsID39Img from '@assets/images/icon/sports_icon/gray/sport_id_39.png'
import SportsID43Img from '@assets/images/icon/sports_icon/gray/sport_id_43.png'
import SportsID44Img from '@assets/images/icon/sports_icon/gray/sport_id_44.png'
import SportsID45Img from '@assets/images/icon/sports_icon/gray/sport_id_45.png'
import SportsID46Img from '@assets/images/icon/sports_icon/gray/sport_id_46.png'
import SportsID47Img from '@assets/images/icon/sports_icon/gray/sport_id_47.png'
import SportsID48Img from '@assets/images/icon/sports_icon/gray/sport_id_48.png'
import SportsID49Img from '@assets/images/icon/sports_icon/gray/sport_id_49.png'
import SportsID50Img from '@assets/images/icon/sports_icon/gray/sport_id_50.png'
import SportsID51Img from '@assets/images/icon/sports_icon/gray/sport_id_51.png'
import SportsID55Img from '@assets/images/icon/sports_icon/gray/sport_id_55.png'
import SportsID60Img from '@assets/images/icon/sports_icon/gray/sport_id_60.png'
import SportsID61Img from '@assets/images/icon/sports_icon/gray/sport_id_61.png'
import SportsID76Img from '@assets/images/icon/sports_icon/gray/sport_id_76.png'
import SportsID81Img from '@assets/images/icon/sports_icon/gray/sport_id_81.png'
import SportsID102Img from '@assets/images/icon/sports_icon/gray/sport_id_102.png'
import SportsID103Img from '@assets/images/icon/sports_icon/gray/sport_id_103.png'
import SportsID104Img from '@assets/images/icon/sports_icon/gray/sport_id_104.png'
import SportsID105Img from '@assets/images/icon/sports_icon/gray/sport_id_105.png'
import SportsID106Img from '@assets/images/icon/sports_icon/gray/sport_id_106.png'
import SportsID109Img from '@assets/images/icon/sports_icon/gray/sport_id_109.png'
import SportsID110Img from '@assets/images/icon/sports_icon/gray/sport_id_110.png'
import SportsID111Img from '@assets/images/icon/sports_icon/gray/sport_id_111.png'
import SportsID112Img from '@assets/images/icon/sports_icon/gray/sport_id_112.png'
import SportsID113Img from '@assets/images/icon/sports_icon/gray/sport_id_113.png'
import SportsID117Img from '@assets/images/icon/sports_icon/gray/sport_id_117.png'
import SportsID118Img from '@assets/images/icon/sports_icon/gray/sport_id_118.png'
import SportsID119Img from '@assets/images/icon/sports_icon/gray/sport_id_119.png'
import SportsID121Img from '@assets/images/icon/sports_icon/gray/sport_id_121.png'
import SportsID125Img from '@assets/images/icon/sports_icon/gray/sport_id_125.png'
import SportsID127Img from '@assets/images/icon/sports_icon/gray/sport_id_127.png'
import SportsID128Img from '@assets/images/icon/sports_icon/gray/sport_id_128.png'
import SportsID135Img from '@assets/images/icon/sports_icon/gray/sport_id_135.png'
import SportsID136Img from '@assets/images/icon/sports_icon/gray/sport_id_136.png'
import SportsID137Img from '@assets/images/icon/sports_icon/gray/sport_id_137.png'
import SportsID138Img from '@assets/images/icon/sports_icon/gray/sport_id_138.png'
import SportsID140Img from '@assets/images/icon/sports_icon/gray/sport_id_140.png'
import SportsID142Img from '@assets/images/icon/sports_icon/gray/sport_id_142.png'
import SportsID152Img from '@assets/images/icon/sports_icon/gray/sport_id_152.png'
import SportsID153Img from '@assets/images/icon/sports_icon/gray/sport_id_153.png'
import SportsID155Img from '@assets/images/icon/sports_icon/gray/sport_id_155.png'
import SportsID156Img from '@assets/images/icon/sports_icon/gray/sport_id_156.png'
import SportsID157Img from '@assets/images/icon/sports_icon/gray/sport_id_157.png'
import SportsID160Img from '@assets/images/icon/sports_icon/gray/sport_id_160.png'
import SportsID162Img from '@assets/images/icon/sports_icon/gray/sport_id_162.png'
import SportsID170Img from '@assets/images/icon/sports_icon/gray/sport_id_170.png'
import { LogoIco } from '@shared/Icon/LogoIcon'
import { LS_SPORT_ID } from 'adv-protocol/src/GameCommon'

export const SPORT_ID_GRAY_ICON_MAP = {
  '1': <img src={SportsID1Img} alt="Soccer" />, // default
  '2': <img src={SportsID2Img} alt="Basketball" />,
  '3': <img src={SportsID3Img} alt="Baseball" />,
  '4': <img src={SportsID4Img} alt="Ice Hockey" />,
  '5': <img src={SportsID5Img} alt="Tennis" />,
  '6': <img src={SportsID6Img} alt="Handball" />,
  '7': <img src={SportsID7Img} alt="Floorball" />,
  '9': <img src={SportsID9Img} alt="Golf" />,
  '10': <img src={SportsID10Img} alt="Boxing" />,
  '11': <img src={SportsID11Img} alt="Motor Sport" />,
  '12': <img src={SportsID12Img} alt="Rugby" />,
  '13': <img src={SportsID13Img} alt="Aussie Rules" />,
  '14': <img src={SportsID14Img} alt="Winter Sports" />,
  '15': <img src={SportsID15Img} alt="Bandy" />,
  '16': <img src={SportsID16Img} alt="Football" />,
  '17': <img src={SportsID17Img} alt="Cycling" />,
  '18': <img src={SportsID18Img} alt="Specials" />,
  '19': <img src={SportsID19Img} alt="Snooker" />,
  '20': <img src={SportsID20Img} alt="Table Tennis" />,
  '21': <img src={SportsID21Img} alt="Cricket" />,
  '22': <img src={SportsID22Img} alt="Darts" />,
  '23': <img src={SportsID23Img} alt="Volleyball" />,
  '24': <img src={SportsID24Img} alt="Field Hockey" />,
  '25': <img src={SportsID25Img} alt="Pool" />,
  '26': <img src={SportsID26Img} alt="Waterpolo" />,
  '28': <img src={SportsID28Img} alt="Curling" />,
  '29': <img src={SportsID29Img} alt="Futsal" />,
  '31': <img src={SportsID31Img} alt="Badminton" />,
  '32': <img src={SportsID32Img} alt="Bowls" />,
  '34': <img src={SportsID34Img} alt="Beach Volley" />,
  '36': <img src={SportsID36Img} alt="Athletics" />,
  '37': <img src={SportsID37Img} alt="Squash" />,
  '38': <img src={SportsID38Img} alt="Rink Hockey" />,
  '39': <img src={SportsID39Img} alt="Lacrosse" />,
  '43': <img src={SportsID43Img} alt="Alpine Skiing" />,
  '44': <img src={SportsID44Img} alt="Biathlon" />,
  '45': <img src={SportsID45Img} alt="Bobsleigh" />,
  '46': <img src={SportsID46Img} alt="Cross-Country" />,
  '47': <img src={SportsID47Img} alt="Nordic Combined" />,
  '48': <img src={SportsID48Img} alt="Ski Jumping" />,
  '49': <img src={SportsID49Img} alt="Snowboard" />,
  '50': <img src={SportsID50Img} alt="Speed Skating" />,
  '51': <img src={SportsID51Img} alt="Luge" />,
  '55': <img src={SportsID55Img} alt="Horse Racing" />,
  '60': <img src={SportsID60Img} alt="Beach Soccer" />,
  '61': <img src={SportsID61Img} alt="Pesapallo" />,
  '76': <img src={SportsID76Img} alt="Equestrian" />,
  '81': <img src={SportsID81Img} alt="Sailing" />,
  '102': <img src={SportsID102Img} alt="Figure Skating" />,
  '103': <img src={SportsID103Img} alt="Freestyle Skating" />,
  '104': <img src={SportsID104Img} alt="Skeleton" />,
  '105': <img src={SportsID105Img} alt="Short Track Speed Skating" />,
  '106': <img src={SportsID106Img} alt="Soccer Mythical" />,
  '109': <img src={SportsID109Img} alt="Esport Counter-Strike" />,
  '110': <img src={SportsID110Img} alt="Esport League Of Legends" />,
  '111': <img src={SportsID111Img} alt="Esport Dota" />,
  '112': <img src={SportsID112Img} alt="Esport Starcraft" />,
  '113': <img src={SportsID113Img} alt="Esport Hearthstone" />,
  '117': <img src={SportsID117Img} alt="MMA" />,
  '118': <img src={SportsID118Img} alt="Esport Call Of Duty" />,
  '119': <img src={SportsID119Img} alt="Esport Smite" />,
  '121': <img src={SportsID121Img} alt="Esport Overwatch" />,
  '125': <img src={SportsID125Img} alt="Esport Rainbow Six" />,
  '127': <img src={SportsID127Img} alt="Esport Street Fighter V" />,
  '128': <img src={SportsID128Img} alt="Esport Rocket League" />,
  '135': <img src={SportsID135Img} alt="Gaelic Football" />,
  '136': <img src={SportsID136Img} alt="Gaelic Hurling" />,
  '137': <img src={SportsID137Img} alt="Esport FIFA" />,
  '138': <img src={SportsID138Img} alt="Kabaddi" />,
  '140': <img src={SportsID140Img} alt="Esport Playerunknowns Battlegro" />,
  '142': <img src={SportsID142Img} alt="Formula E" />,
  '152': <img src={SportsID152Img} alt="Esport World Of Warcraft " />,
  '153': <img src={SportsID153Img} alt="Esport NBA2K" />,
  '155': <img src={SportsID155Img} alt="Basketball 3X3" />,
  '156': <img src={SportsID156Img} alt="Esport Tekken" />,
  '157': <img src={SportsID157Img} alt="Beach Handball" />,
  '160': <img src={SportsID160Img} alt="Esport SSBM" />,
  '162': <img src={SportsID162Img} alt="Esport Artifact" />,
  '170': <img src={SportsID170Img} alt="Esport Fortnite" />,
  '178': <LogoIco />,
}

export const LS_SPORT_ID_ICON_MAP = {
  [LS_SPORT_ID.FOOTBALL]: <img src={SportsID1Img} alt="Soccer" />, // default
  [LS_SPORT_ID.BASKETBALL]: <img src={SportsID2Img} alt="Basketball" />,
  [LS_SPORT_ID.BASEBALL]: <img src={SportsID3Img} alt="Baseball" />,
  [LS_SPORT_ID.ICE_HOCKEY]: <img src={SportsID4Img} alt="Ice Hockey" />,
  [LS_SPORT_ID.TENNIS]: <img src={SportsID5Img} alt="Tennis" />,
  [LS_SPORT_ID.HANDBALL]: <img src={SportsID6Img} alt="Handball" />,
  [LS_SPORT_ID.FLOOR_BALL]: <img src={SportsID7Img} alt="Floorball" />,
  [LS_SPORT_ID.GOLF]: <img src={SportsID9Img} alt="Golf" />,
  [LS_SPORT_ID.BOXING]: <img src={SportsID10Img} alt="Boxing" />,
  [LS_SPORT_ID.MOTOR_SPORTS]: <img src={SportsID11Img} alt="Motor Sport" />,
  [LS_SPORT_ID.MOTOGP]: <img src={SportsID11Img} alt="Motor Sport" />,
  [LS_SPORT_ID.NASCAR]: <img src={SportsID11Img} alt="Motor Sport" />,
  [LS_SPORT_ID.MOTORBIKES]: <img src={SportsID11Img} alt="Motor Sport" />,
  [LS_SPORT_ID.RUGBY_LEAGUE]: <img src={SportsID12Img} alt="Rugby" />,
  [LS_SPORT_ID.RUGBY_UNION]: <img src={SportsID12Img} alt="Rugby" />,
  [LS_SPORT_ID.AUSTRALIAN_RULES]: <img src={SportsID13Img} alt="Aussie Rules" />,
  // [LS_SPORT_ID.SKI_JUMPING]: <img src={SportsID14Img} alt="Winter Sports" />,
  [LS_SPORT_ID.BANDY]: <img src={SportsID15Img} alt="Bandy" />,
  [LS_SPORT_ID.AMERICAN_FOOTBALL]: <img src={SportsID16Img} alt="Football" />,
  [LS_SPORT_ID.CYCLING]: <img src={SportsID17Img} alt="Cycling" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID18Img} alt="Specials" />,
  [LS_SPORT_ID.SNOOKER]: <img src={SportsID19Img} alt="Snooker" />,
  [LS_SPORT_ID.TABLE_TENNIS]: <img src={SportsID20Img} alt="Table Tennis" />,
  [LS_SPORT_ID.CRICKET]: <img src={SportsID21Img} alt="Cricket" />,
  [LS_SPORT_ID.DARTS]: <img src={SportsID22Img} alt="Darts" />,
  [LS_SPORT_ID.VOLLEYBALL]: <img src={SportsID23Img} alt="Volleyball" />,
  [LS_SPORT_ID.HOCKEY]: <img src={SportsID24Img} alt="Field Hockey" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID25Img} alt="Pool" />,
  [LS_SPORT_ID.WATER_POLO]: <img src={SportsID26Img} alt="Waterpolo" />,
  [LS_SPORT_ID.CURLING]: <img src={SportsID28Img} alt="Curling" />,
  [LS_SPORT_ID.FUTSAL]: <img src={SportsID29Img} alt="Futsal" />,
  [LS_SPORT_ID.BADMINTON]: <img src={SportsID31Img} alt="Badminton" />,
  [LS_SPORT_ID.BOWLS]: <img src={SportsID32Img} alt="Bowls" />,
  [LS_SPORT_ID.BEACH_VOLLEYBALL]: <img src={SportsID34Img} alt="Beach Volley" />,
  [LS_SPORT_ID.ATHLETICS]: <img src={SportsID36Img} alt="Athletics" />,
  [LS_SPORT_ID.SQUASH]: <img src={SportsID37Img} alt="Squash" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID38Img} alt="Rink Hockey" />,
  [LS_SPORT_ID.LACROSSE]: <img src={SportsID39Img} alt="Lacrosse" />,
  [LS_SPORT_ID.ALPINE_SKIING]: <img src={SportsID43Img} alt="Alpine Skiing" />,
  [LS_SPORT_ID.BIATHLON]: <img src={SportsID44Img} alt="Biathlon" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID45Img} alt="Bobsleigh" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID46Img} alt="Cross-Country" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID47Img} alt="Nordic Combined" />,
  [LS_SPORT_ID.SKI_JUMPING]: <img src={SportsID48Img} alt="Ski Jumping" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID49Img} alt="Snowboard" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID50Img} alt="Speed Skating" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID51Img} alt="Luge" />,
  [LS_SPORT_ID.HORSE_RACING]: <img src={SportsID55Img} alt="Horse Racing" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID60Img} alt="Beach Soccer" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID61Img} alt="Pesapallo" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID76Img} alt="Equestrian" />,
  [LS_SPORT_ID.SAILING]: <img src={SportsID81Img} alt="Sailing" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID102Img} alt="Figure Skating" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID103Img} alt="Freestyle Skating" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID104Img} alt="Skeleton" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID105Img} alt="Short Track Speed Skating" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID106Img} alt="Soccer Mythical" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID109Img} alt="Esport Counter-Strike" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID110Img} alt="Esport League Of Legends" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID111Img} alt="Esport Dota" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID112Img} alt="Esport Starcraft" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID113Img} alt="Esport Hearthstone" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID117Img} alt="MMA" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID118Img} alt="Esport Call Of Duty" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID119Img} alt="Esport Smite" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID121Img} alt="Esport Overwatch" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID125Img} alt="Esport Rainbow Six" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID127Img} alt="Esport Street Fighter V" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID128Img} alt="Esport Rocket League" />,
  [LS_SPORT_ID.GAELIC_SPORTS]: <img src={SportsID135Img} alt="Gaelic Football" />,
  [LS_SPORT_ID.HURLING]: <img src={SportsID136Img} alt="Gaelic Hurling" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID137Img} alt="Esport FIFA" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID138Img} alt="Kabaddi" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID140Img} alt="Esport Playerunknowns Battlegro" />,
  [LS_SPORT_ID.FORMULA_1]: <img src={SportsID142Img} alt="Formula E" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID152Img} alt="Esport World Of Warcraft " />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID153Img} alt="Esport NBA2K" />,
  [LS_SPORT_ID.BASKETBALL_3X3]: <img src={SportsID155Img} alt="Basketball 3X3" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID156Img} alt="Esport Tekken" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID157Img} alt="Beach Handball" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID160Img} alt="Esport SSBM" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID162Img} alt="Esport Artifact" />,
  // [LS_SPORT_ID.BASKETBALL]: <img src={SportsID170Img} alt="Esport Fortnite" />,
  [LS_SPORT_ID.E_GAMES]: <LogoIco />,
  [LS_SPORT_ID.GREYHOUNDS]: <LogoIco />,
  [LS_SPORT_ID.TROTTING]: <LogoIco />,
  [LS_SPORT_ID.SPEEDWAY]: <LogoIco />,
  [LS_SPORT_ID.CHESS]: <LogoIco />,
  [LS_SPORT_ID.EQUINE_SPORTS]: <LogoIco />,
  [LS_SPORT_ID.SUPERCARS]: <LogoIco />,
  [LS_SPORT_ID.NETBALL]: <LogoIco />,
  [LS_SPORT_ID.SURFING]: <LogoIco />,
  [LS_SPORT_ID.SUMO]: <LogoIco />,
  [LS_SPORT_ID.VIRTUAL_SPORTS]: <LogoIco />,
  [LS_SPORT_ID.POLITICS]: <LogoIco />,
  [LS_SPORT_ID.WEATHER]: <LogoIco />,
  [LS_SPORT_ID.TV_GAMES]: <LogoIco />,
  [LS_SPORT_ID.LOTTERY]: <LogoIco />,
  [LS_SPORT_ID.POKER]: <LogoIco />,
  [LS_SPORT_ID.INDY]: <LogoIco />,
}
